import Head from 'next/head';
import React, { FC } from 'react';

import SolutionHave from '@/components/elements/solution-have';

import { Footer } from '@/widgets/footer';
import { Header } from '@/widgets/header';

import { HowWorkServiceBanner, HowWorkService, Benefits } from '@/entities/info';
import { QuestionsList, TQuestion } from '@/entities/question';

import { QUESTIONS_URL } from '@/shared/constants/paths';
import { useTranslate } from '@/shared/hooks/use-translate';
import { Layout } from '@/shared/ui/layout';
import { LinkPageSection } from '@/shared/ui/link-page-section';
import { PageSection } from '@/shared/ui/page-section';

type TProps = {
    title: string;
    description: string;
    questions: TQuestion[];
};

export const HowItWorkPage: FC<TProps> = ({ title, description, questions }) => {
    const { t } = useTranslate();

    return (
        <Layout noMargin={true} header={<Header />} footer={<Footer />}>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Head>
            <HowWorkServiceBanner />
            <Layout.Content>
                <SolutionHave />
                <HowWorkService />
                <Benefits />
                <PageSection
                    title={t('Самые частые вопросы')}
                    linkComponent={<LinkPageSection title={t('Все вопросы')} href={QUESTIONS_URL} />}
                >
                    <QuestionsList questions={questions} />
                </PageSection>
            </Layout.Content>
        </Layout>
    );
};
